<template>
  <div v-frag>
    <CardIeaAppMain>
      <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
        <CardIeaApp colorCard="#A7BA38" title="Validacion">
          <v-row align="center" align-content="center" justify="center">
            <v-fade-transition>
              <div v-frag v-if="cantidadIntentosEmail == 2">
                <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
                  <v-alert
                    border="bottom"
                    colored-border
                    type="warning"
                    elevation="0"
                  >
                    ¡UPS! Lamentamos que no hayas podido validar este dato, no
                    te preocupes, este paso es opcional
                  </v-alert>
                </v-col>
              </div>
              <div v-frag v-if="!validadoEmail && cantidadIntentosEmail < 2">
                <!-- <v-col cols="2" sm="3" xs="3" md="4" lg="3" xl="4"></v-col> -->
                <v-col
                  cols="12"
                  sm="12"
                  xs="12"
                  md="12"
                  lg="12"
                  xl="12"
                  align="center"
                >
                  <VueFakeInput
                    :length="4"
                    :fontSize="40"
                    inputColor="#1565C0"
                    borderColor="#000000"
                    fontColor="#000000"
                    :allowPaste="false"
                    v-model="codeEmail"
                    :code="codeEmail"
                    @change="store(1)"
                  />
                </v-col>
                <!-- <v-col cols="2" sm="3" xs="3" md="3" lg="3" xl="4"></v-col> -->
                <v-col
                  cols="12"
                  sm="12"
                  xs="12"
                  md="12"
                  lg="12"
                  xl="12"
                  class="text-center"
                >
                  <span
                    >Hemos eviado un Email a {{ emailEnviado }},
                    <a @click="panelEmail = !panelEmail"
                      >¿no recibiste el código?</a
                    ></span
                  >
                </v-col>

                <v-expand-transition>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    xl="12"
                    v-show="panelEmail"
                  >
                    <InputCustom :inputProp="inputs[0]" />
                  </v-col>
                </v-expand-transition>

                <v-expand-transition>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    xl="12"
                    v-show="panelEmail"
                  >
                    <v-btn
                      @click="resetCode(1)"
                      block
                      x-large
                      class="white--text rounded-lg font-weight-regular"
                      depressed
                      color="btnSuccess"
                      :loading="loader"
                      >Modificar</v-btn
                    >
                  </v-col>
                </v-expand-transition>
              </div>
            </v-fade-transition>

            <br /><br /><br />

            <v-fade-transition>
              <v-col
                cols="12"
                sm="12"
                xs="12"
                md="12"
                lg="12"
                xl="12"
                v-if="cantidadIntentosSms == 2"
              >
                <v-alert
                  border="bottom"
                  colored-border
                  type="warning"
                  elevation="0"
                >
                  ¡UPS! Lamentamos que no hayas podido validar este dato, no te
                  preocupes, este paso es opcional
                </v-alert>
              </v-col>

              <div v-frag v-if="!validadoSms && cantidadIntentosSms < 2">
                <v-col
                  cols="12"
                  sm="12"
                  xs="12"
                  md="12"
                  lg="12"
                  xl="12"
                  align="center"
                >
                  <VueFakeInput
                    :length="4"
                    :fontSize="40"
                    inputColor="#1565C0"
                    borderColor="#000000"
                    fontColor="#000000"
                    :allowPaste="false"
                    v-model="codeSms"
                    :code="codeSms"
                  />
                </v-col>

                <v-col
                  cols="12"
                  xs="12"
                  sm="12"
                  md="12"
                  lg="12"
                  xl="12"
                  class="text-center"
                >
                  <span
                    >Hemos eviado un Sms a +{{ numeroEnviado }},
                    <a @click="panelSms = !panelSms"
                      >¿no recibiste el código?</a
                    ></span
                  >
                </v-col>

                <v-expand-transition>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="2"
                    lg="2"
                    xl="2"
                    v-show="panelSms"
                  >
                    <InputCustom :inputProp="inputs[3]" />
                  </v-col>
                </v-expand-transition>

                <v-expand-transition>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="4"
                    lg="4"
                    xl="4"
                    v-show="panelSms"
                  >
                    <InputCustom :inputProp="inputs[1]" />
                  </v-col>
                </v-expand-transition>

                <v-expand-transition>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="6"
                    lg="6"
                    xl="6"
                    v-show="panelSms"
                  >
                    <InputCustom :inputProp="inputs[2]" />
                  </v-col>
                </v-expand-transition>

                <v-expand-transition>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="12"
                    xl="12"
                    v-show="panelSms"
                  >
                    <v-btn
                      @click="resetCode(2)"
                      block
                      x-large
                      class="white--text rounded-lg font-weight-regular"
                      depressed
                      color="btnSuccess"
                      :loading="loader"
                      >Modificar</v-btn
                    >
                  </v-col>
                </v-expand-transition>
              </div>
            </v-fade-transition>

            <v-fade-transition>
              <v-col
                cols="12"
                xs="12"
                sm="12"
                md="12"
                lg="12"
                xl="12"
                v-if="cantidadIntentosEmail >= 2 || cantidadIntentosSms >= 2"
              >
                <v-btn block color="info" @click="finish()">
                  Omitir
                </v-btn>
              </v-col>
            </v-fade-transition>

            <!-- <div v-frag v-if="!validadoSms && cantidadIntentosSms < 2">   -->

            <br /><br /><br />

            <!-- <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" >
            <v-btn
                @click="store()"
                block
                large
                class="white--text mt-3"
                depressed
                color="btnSuccess"
                :loading="loader"
                >Modificar</v-btn
              >
          </v-col> -->
          </v-row>
        </CardIeaApp>
      </v-col>
    </CardIeaAppMain>
    <v-dialog v-model="dialogResetCode" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          Atención!
        </v-card-title>

        <v-card-text class="mt-2">
          Se ha reenviado el código de validación.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogResetCode = false">
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog" width="500" persistent>
      <v-card>
        <v-card-title class="headline grey lighten-2">
          Atención!
        </v-card-title>

        <v-card-text class="mt-2">
          La informacion se ha guardado con éxito.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="finish()">
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CardIeaAppMain from "../../components/CardIeaAppMain";
import CardIeaApp from "../../components/CardIeaApp";
import VueFakeInput from "../../components/VueFakeInput";
import InputCustom from "../../components/InputCustom";
import MessagesRules from "../../config/MessagesRules";
export default {
  name: "Validacion",
  components: {
    CardIeaAppMain,
    CardIeaApp,
    VueFakeInput,
    InputCustom
  },
  mounted() {
    this.finish();
    //this.loadInitial();
  },
  watch: {
    codeEmail: function(val) {
      if (val.length == 4) {
        this.store(1);
      }
      return val;
    },
    codeSms: function(val) {
      if (val.length == 4) {
        this.store(2);
      }
      return val;
    }
  },
  data: () => ({
    codeEmail: "",
    codeSms: "",
    loader: false,
    dialog: false,
    dialogResetCode: false,
    panelSms: false,
    panelEmail: false,
    validadoEmail: false,
    validadoSms: false,
    cantidadValidados: 2,
    cantidadMaxValidados: 2,
    cantidadIntentosEmail: 0,
    cantidadIntentosSms: 0,
    emailEnviado: "",
    numeroEnviado: "",
    inputs: [
      {
        tag: "email",
        text: "Email",
        placeholder: "ejemplo@ejemplo.com",
        icon: "mdi-email",
        required: true,
        value: "",
        type: "email",
        rules: [
          v => !!v || "Email" + MessagesRules.required,
          v => /.+@.+\..+/.test(v) || MessagesRules.email
        ],
        counter: 0
      },
      {
        tag: "areaCelular",
        text: "N° Area celular",
        placeholder: "####",
        icon: "mdi-cellphone",
        required: true,
        value: "",
        type: "number",
        mask: "####",
        rules: [v => !!v || "Area" + MessagesRules.required],
        counter: 0
      },
      {
        tag: "telefonoCelular",
        text: "Celular - movil",
        placeholder: "########",
        icon: "mdi-cellphone",
        required: true,
        value: "",
        type: "number",
        mask: "########",
        rules: [v => !!v || "Telefono" + MessagesRules.required],
        counter: 0
      },
      {
        tag: "areaCelular2",
        text: "Código",
        placeholder: "####",
        icon: "mdi-cellphone",
        required: true,
        readonly: true,
        disabled: true,
        value: "+549",
        type: "text",
        mask: "+###",
        rules: [v => !!v || "Area" + MessagesRules.required],
        counter: 0
      }
    ]
  }),
  methods: {
    async resetCode(tipo) {
      if (this.cantidadIntentosEmail == 2) {
        return;
      }
      if (this.cantidadIntentosSms == 2) {
        return;
      }
      await this.$API
        .post({
          url: "circuito/resetCode",
          data: {
            alumno: this.$store.getters.inscripto.id,
            email: this.inputs[0].value,
            areaCelular: this.inputs[1].value,
            telefonoCelular: this.inputs[2].value,
            tipo: tipo
          }
        })
        .then(() => {
          if (tipo == 1) {
            this.emailEnviado = this.inputs[0].value;
            this.cantidadIntentosEmail++;
          } else {
            this.numeroEnviado =
              "549" +
              this.inputs[1].value.toString() +
              this.inputs[2].value.toString();
            this.cantidadIntentosSms++;
          }
          this.codeEmail = "";
          this.codeSms = "";
          this.panelEmail = false;
          this.panelSms = false;
          this.inputs[0].value = "";
          this.inputs[1].value = "";
          this.inputs[2].value = "";
          this.dialogResetCode = true;
        })
        .catch(() => {
          this.codeEmail = "";
          this.codeSms = "";
          this.inputs[0].value = "";
          this.inputs[1].value = "";
          this.inputs[2].value = "";
        });
    },
    async store(tipo) {
      this.loading = true;
      await this.$API
        .post({
          url: "circuito/validacion",
          data: {
            codeEmail: this.codeEmail,
            codeSms: this.codeSms,
            alumno: this.$store.getters.inscripto.id,
            // email: this.inputs[0].value,
            // areaCelular: this.inputs[1].value,
            // telefonoCelular: this.inputs[2].value,
            tipo: tipo
          }
        })
        .then(() => {
          this.loading = false;
          this.cantidadValidados++;
          if (tipo == 1) {
            this.validadoEmail = true;
          } else {
            this.validadoSms = true;
          }
          if (this.cantidadValidados == this.cantidadMaxValidados) {
            this.dialog = true;
          }
        })
        .catch(() => {
          this.loading = false;
          if (tipo == 1) {
            this.panelEmail = true;
            this.codeEmail = "";
          } else {
            this.panelSms = true;
            this.codeSms = "";
          }
        });
    },
    async loadInitial() {
      this.emailEnviado = this.$store.getters.inscripto.email;
      this.numeroEnviado = this.$store.getters.inscripto.numero;
      // this.cantidadMaxValidados = 0

      if (
        !this.$store.getters.inscripto.validarSms ||
        this.$store.getters.inscripto.validarSms == 0
      ) {
        this.cantidadMaxValidados--;
        this.validadoSms = true;
      }

      if (
        !this.$store.getters.inscripto.validarEmail ||
        this.$store.getters.inscripto.validarEmail == 0
      ) {
        this.cantidadMaxValidados--;
        this.validadoEmail = true;
      }
      // this.inputs[0].value = this.$store.getters.inscripto.email;
      // this.inputs[1].value = this.$store.getters.inscripto.areaCelular;
      // this.inputs[2].value = this.$store.getters.inscripto.telefonoCelular;
    },
    finish() {
      this.dialog = false;
      let url = this.$store.getters.inscripto.url;
      this.$store.dispatch("circuito", "");
      this.$store.dispatch("preinscrito", "");
      this.$store.dispatch("inscripto", "");
      setTimeout(() => {
        window.location.href = "http://" + url;
      }, 1000);
    }
  }
};
</script>
